import React, { Fragment, useEffect, useState } from 'react';
import BasicFormComponent from '../../components/formComponent/BasicFormComponent';
import FormSearchSelect from "../../components/general/FormSearchSelect";
import FormTextField from '../../components/general/FormTextField';
import { Button, Col, message, Row, Space, Table, Input, Switch } from "antd";
import FormSelect from '../../components/general/FormSelect';
import { postRequest } from '../../services/mainApp.service';
import { useDispatch, useSelector } from "react-redux";

const ProductRemoteCode = () => {
    const controller = new window.AbortController();
    const userData = useSelector((state) => state.authReducer);
    const { formLoading } = useSelector((state) => state.basicFormReducer);

    const [itemsList, setItemsList] = useState([]);
    const [category, setCategory] = useState([]);
    const [branches, setBranches] = useState([]);
    const [product, setProduct] = useState([]);
    const [size, setSize] = useState([]);
    const [variant, setVariant] = useState([]);
    const [productRemoteCodeData, setProductRemoteCodeData] = useState(null);
    const [searchValues, setSearchValues] = useState({
        CategoryId: null,
        ProductId: null,
        SizeId: null,
        FlavorId: null,
        BranchId: null,
    });
    const [changedRemoteCodes, setChangedRemoteCodes] = useState([]);
    const [showMissingCodesOnly, setShowMissingCodesOnly] = useState(false);
    const [initialEmptyItems, setInitialEmptyItems] = useState([]);
    const [branchWiseEntry, setBranchWiseEntry] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);

    const initialFormValues = {
        "OperationId": 1,
        "BranchId": null,
        "CompanyId": userData?.CompanyId,
        "UserId": userData?.UserId,
        "UserIP": userData?.UserIP,
        "ProductId": null,
        "SizeId": null,
        "FlavorId": null,
        "CategoryId": null,
        "RemoteCode": null,
        "ProductRemoteCode": []
    };

    const initialRemoteCode = async (url, data, controller) => {
        try {
            const response = await postRequest(url, data, controller);
            return response;
        } catch (error) {
            console.error('Error in initialRemoteCode:', error);
            throw error;
        }
    };

    useEffect(() => {
        const fetchProductRemoteCode = async () => {
            setDataLoading(true);
            try {
                const response = await initialRemoteCode('/UpdateProductDetailRemoteCode', initialFormValues, controller);
                setProductRemoteCodeData(response);
                setItemsList(response?.data?.DataSet?.Table || []);
                const emptyItems = (response?.data?.DataSet?.Table || []).filter(
                    item => !item.RemoteId || item.RemoteId === "" || item.RemoteId === "0"
                );
                setInitialEmptyItems(emptyItems);
                setProduct(response?.data?.DataSet?.Table1 || []);
                setCategory(response?.data?.DataSet?.Table4 || []);
                setBranches(response?.data?.DataSet?.Table5 || []);
                setSize(response?.data?.DataSet?.Table2 || []);
                setVariant(response?.data?.DataSet?.Table3 || []);
            } catch (error) {
                console.error('Error fetching product remote code:', error);
            } finally {
                setDataLoading(false);
            }
        };

        fetchProductRemoteCode();

        return () => {
            controller.abort();
        };
    }, []);

    const handleSearchChange = (data) => {

        setSearchValues((prevState) => ({
            ...prevState,
            [data.name]: data.value,
        }));

    };

    // console.log('searchValues', searchValues);

    const handleReset = () => {
        const resetData = productRemoteCodeData?.data?.DataSet?.Table || [];
        setItemsList(resetData);

        // Recalculate initial empty items based on reset data
        const emptyItems = resetData.filter(
            item => !item.RemoteId || item.RemoteId === "" || item.RemoteId === "0"
        );
        setInitialEmptyItems(emptyItems);

        setSearchValues({
            CategoryId: null,
            ProductId: null,
            SizeId: null,
            FlavorId: null,
            BranchId: null,
        });
        setChangedRemoteCodes([]); // Reset changed remote codes on reset
    };

    const handleSearchSubmit = async (e) => {
        e.preventDefault();

        // If branch-wise entry is enabled and a branch is selected, fetch branch-specific data from API
        if (branchWiseEntry && searchValues.BranchId) {
            setDataLoading(true);
            const searchFields = {
                ...initialFormValues,
                "ProductId": searchValues.ProductId,
                "SizeId": searchValues.SizeId,
                "FlavorId": searchValues.FlavorId,
                "CategoryId": searchValues.CategoryId,
                "BranchId": searchValues.BranchId,
            };
            try {
                const response = await initialRemoteCode('/UpdateProductDetailRemoteCode', searchFields, controller);
                const searchResults = response?.data?.DataSet?.Table6 || [];

                // Apply additional filters if any other search criteria are provided
                let filteredResults = searchResults;
                if (searchValues.CategoryId || searchValues.ProductId || searchValues.SizeId || searchValues.FlavorId) {
                    filteredResults = searchResults.filter(item => {
                        if (searchValues.CategoryId && item.CategoryId !== searchValues.CategoryId) return false;
                        if (searchValues.ProductId && item.ProductId !== searchValues.ProductId) return false;
                        if (searchValues.SizeId && item.SizeId !== searchValues.SizeId) return false;
                        if (searchValues.FlavorId && item.FlavorId !== searchValues.FlavorId) return false;
                        return true;
                    });
                }

                setItemsList(filteredResults);

                // Recalculate initial empty items based on search results
                const emptyItems = filteredResults.filter(
                    item => !item.RemoteId || item.RemoteId === "" || item.RemoteId === "0"
                );
                setInitialEmptyItems(emptyItems);
                setChangedRemoteCodes([]);
            } catch (error) {
                console.error('Error fetching product remote code:', error);
                message.error('Failed to fetch search results. Please try again.');
            } finally {
                setDataLoading(false);
            }
        } else {
            // Filter locally from already-fetched data
            const allData = productRemoteCodeData?.data?.DataSet?.Table || [];

            let filteredData = allData.filter(item => {
                // Filter by CategoryId
                if (searchValues.CategoryId && item.CategoryId !== searchValues.CategoryId) {
                    return false;
                }

                // Filter by ProductId
                if (searchValues.ProductId && item.ProductId !== searchValues.ProductId) {
                    return false;
                }

                // Filter by SizeId
                if (searchValues.SizeId && item.SizeId !== searchValues.SizeId) {
                    return false;
                }

                // Filter by FlavorId
                if (searchValues.FlavorId && item.FlavorId !== searchValues.FlavorId) {
                    return false;
                }

                return true;
            });

            setItemsList(filteredData);

            // Recalculate initial empty items based on filtered results
            const emptyItems = filteredData.filter(
                item => !item.RemoteId || item.RemoteId === "" || item.RemoteId === "0"
            );
            setInitialEmptyItems(emptyItems);
            setChangedRemoteCodes([]);
        }

        // Clear search values after filtering
        setSearchValues({
            CategoryId: null,
            ProductId: null,
            SizeId: null,
            FlavorId: null,
            BranchId: null,
        });

    };

    const handleRemoteCodeChange = (record, newValue) => {
        // Update items list
        setItemsList((prevState) =>
            prevState.map(item =>
                item.ProductDetailId === record?.ProductDetailId ? { ...item, RemoteId: newValue } : item
            )
        );

        // Update initial empty items
        setInitialEmptyItems((prevState) =>
            prevState.map(item =>
                item.ProductDetailId === record?.ProductDetailId ? { ...item, RemoteId: newValue } : item
            )
        );

        // Update changed remote codes with BranchId if branchWiseEntry is true
        setChangedRemoteCodes((prevState) => {
            const existingIndex = prevState.findIndex(item =>
                item.ProductDetailId === record?.ProductDetailId &&
                (!branchWiseEntry || item.BranchId === record?.BranchId)
            );

            if (existingIndex !== -1) {
                const updatedState = [...prevState];
                updatedState[existingIndex] = {
                    ...updatedState[existingIndex],
                    RemoteCode: newValue,
                    ...(branchWiseEntry && { BranchId: record?.BranchId }) // Add BranchId if branchWiseEntry
                };
                return updatedState;
            }

            return [
                ...prevState,
                {
                    ProductDetailId: record?.ProductDetailId,
                    RemoteCode: newValue,
                    ...(branchWiseEntry && { BranchId: record?.BranchId }) // Add BranchId if branchWiseEntry
                }
            ];
        });
    };

    const handleSave = async () => {
        const saveData = {
            ...initialFormValues,
            "OperationId": 3,
            "ProductRemoteCode": changedRemoteCodes,
        };
        setDataLoading(true);
        try {
            const response = await postRequest('/UpdateProductDetailRemoteCode', saveData, controller);
            if (response) {
                message.success('Remote codes updated successfully.');

                // 1. Update items list with fresh values
                if (branchWiseEntry) {
                    const updatedItems = response?.data?.DataSet?.Table6 || [];
                    // const updatedItemsWithBranch = updatedItems.filter(item => item.BranchId === searchValues.BranchId);
                    setItemsList(updatedItems);
                } else {
                    const updatedItems = response?.data?.DataSet?.Table1 || [];
                    setItemsList(updatedItems);
                }


                // 2. Recalculate which are still empty
                const emptyItems = updatedItems.filter(item => !item.RemoteId || item.RemoteId === "" || item.RemoteId === "0");
                setInitialEmptyItems(emptyItems);

                setChangedRemoteCodes([]); // Reset the changed remote codes after successful save

            } else {
                message.error('Failed to update remote codes.');
            }
        } catch (error) {

        } finally {
            setDataLoading(false);
        }
    };

    const searchPanel = (
        <Fragment>
            {
                branchWiseEntry && (
                    <FormSelect
                        colSpan={4}
                        listItem={branches}
                        idName="BranchId"
                        valueName="BranchName"
                        name="BranchId"
                        label="Branch"
                        value={searchValues.BranchId}
                        onChange={handleSearchChange}
                    />
                )
            }

            <FormSelect
                colSpan={4}
                listItem={category}
                idName="CategoryId"
                valueName="CategoryName"
                name="CategoryId"
                label="Category"
                value={searchValues.CategoryId}
                onChange={handleSearchChange}
            />
            <FormSearchSelect
                colSpan={4}
                listItem={product}
                idName="ProductId"
                valueName="ProductName"
                name="ProductId"
                label="Product Name"
                value={searchValues.ProductId}
                onChange={handleSearchChange}
            />
            <FormSelect
                colSpan={4}
                listItem={size}
                idName="SizeId"
                valueName="SizeName"
                name="SizeId"
                label="Size"
                value={searchValues.SizeId}
                onChange={handleSearchChange}
            />
            <FormSelect
                colSpan={4}
                listItem={variant}
                idName="FlavourId"
                valueName="FlavourName"
                name="FlavorId"
                label="Variant"
                value={searchValues.FlavorId}
                onChange={handleSearchChange}
            />
        </Fragment>
    );

    const columns = [
        {
            title: "Product",
            dataIndex: "ProductName",
            key: "ProductName",
        },
        {
            title: "Category",
            dataIndex: "CategoryName",
            key: "CategoryName",
        },
        {
            title: "Price",
            dataIndex: "Price",
            key: "Price",
        },
        {
            title: "Variant",
            dataIndex: "FlavorName",
            key: "FlavorName",
        },
        {
            title: "Size",
            dataIndex: "SizeName",
            key: "SizeName",
        },
        {
            title: "Remote Code",
            key: "RemoteId",
            render: (record) => (
                <Input
                    value={record.RemoteId || ""}
                    onChange={(e) => handleRemoteCodeChange(record, e.target.value)}
                    onKeyPress={(e) => {
                        if (!/^\d*$/.test(e.key)) {
                            e.preventDefault();
                        }
                    }}
                    type="text"
                    required
                    style={{ width: '100%' }}
                />
            ),
        },
    ];

    return (
        <div>
            <Fragment>

                <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }} className='mt-2'>
                    <div className='w-full flex gap-5 justify-end pr-5'>
                        <div className="flex items-center justify-between bg-gray-50  rounded-lg gap-5">
                            <div className="flex flex-col">
                                <span className="text-sm font-semibold text-gray-700">Missing Codes Only</span>
                                <span className="text-xs text-gray-500">Show only items without remote codes</span>
                            </div>
                            <Switch
                                checked={showMissingCodesOnly}
                                onChange={setShowMissingCodesOnly}
                                className={`${showMissingCodesOnly ? 'bg-blue-600' : 'bg-gray-300'}`}
                            />
                        </div>

                        <div className="flex items-center justify-between bg-gray-50  rounded-lg gap-5">
                            <div className="flex flex-col">
                                <span className="text-sm font-semibold text-gray-700">Branch-wise Entry</span>
                                <span className="text-xs text-gray-500">Enter remote codes by branch</span>
                            </div>
                            <Switch
                                checked={branchWiseEntry}
                                onChange={(checked) => {
                                    setBranchWiseEntry(checked); // 1. Toggle the branch-wise mode
                                    setChangedRemoteCodes([]);  // 2. Reset any pending changes
                                }}
                                className={`${branchWiseEntry ? 'bg-blue-600' : 'bg-gray-300'}`}
                            />
                        </div>
                    </div>
                </div>


                <BasicFormComponent
                    formTitle="Product Remote Code"
                    searchPanel={searchPanel}
                    searchSubmit={handleSearchSubmit}
                    tableRows={
                        showMissingCodesOnly
                            ? itemsList.filter(item =>
                                initialEmptyItems.some(emptyItem => emptyItem.ProductDetailId === item.ProductDetailId)
                            )
                            : itemsList
                    }

                    tableColumn={columns}
                    // formLoading={true}
                    tableLoading={dataLoading}
                    reset={true}
                    handleReset={handleReset}
                    handleSave={handleSave}
                    actionID="ProductDetailId"
                />
            </Fragment>
        </div>
    );
};

export default ProductRemoteCode;
